import {
  AuthWsApiBaseUrl,
  AuthenticationApiBaseUrl,
  CloudProviderApiBaseUrls,
  CpihMessageExporterApiBaseUrl,
  PartnerBundleApiBaseUrl,
  TrimbleIdentityApiBaseUrl,
  TripManagementSettingsApiBaseUrl,
} from './api-base-urls';

export class ServiceApiBaseUrls {
  authWsApiBaseUrl!: AuthWsApiBaseUrl;
  authenticationApiBaseUrl!: AuthenticationApiBaseUrl;
  trimbleIdentityApiBaseUrl!: TrimbleIdentityApiBaseUrl;
  tripManagementSettingsApiBaseUrl!: TripManagementSettingsApiBaseUrl;
  cpihMessageExporterApiBaseUrl!: CpihMessageExporterApiBaseUrl;

  cloudProviderApiBaseUrls!: CloudProviderApiBaseUrls;
  partnerBundleApiBaseUrl!: PartnerBundleApiBaseUrl;

  constructor(overrides: ServiceApiBaseUrls) {
    Object.assign(this, overrides);
  }
}
